import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';

interface ErrorDisplayProps {
  error: string;
  onRetry?: () => void;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  showIcon?: boolean;
}

export default function ErrorDisplay({ 
  error, 
  onRetry, 
  className = '', 
  size = 'md',
  showIcon = true 
}: ErrorDisplayProps) {
  const sizeClasses = {
    sm: 'text-sm space-y-2',
    md: 'text-base space-y-4',
    lg: 'text-lg space-y-6'
  };

  const iconSizes = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6'
  };

  const buttonSizes = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2',
    lg: 'px-6 py-3 text-lg'
  };

  return (
    <div className={`text-center ${sizeClasses[size]} ${className}`}>
      <div className="flex items-center justify-center text-red-500 space-x-2">
        {showIcon && <AlertCircle className={iconSizes[size]} />}
        <span>{error}</span>
      </div>
      
      {onRetry && (
        <button
          onClick={onRetry}
          className={`${buttonSizes[size]} bg-primary-500 text-white rounded-lg hover:bg-primary-600 
                     transition-colors flex items-center justify-center space-x-2 mx-auto`}
        >
          <RefreshCw className={iconSizes[size]} />
          <span>Retry</span>
        </button>
      )}
    </div>
  );
}